import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import Table, { TableHookPro } from '../Table';
import { IconButton } from '@mui/material';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';


const TransferTable = ({ getcolumns1, getcolumns2, data1, data2, toRight, toLeft, setState }) => {

    const [table1] = TableHookPro()

    const [table2] = TableHookPro()

    return (
        <>
            <Box sx={{ display: 'flex', gap: '1rem', width: '100%', minHeight: '1rem', height: '100%' }}>

                <Box sx={{ width: '50%', height: '28rem' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton onClick={() => toRight(table1, setState, data1, data2)}><ArrowCircleRightIcon sx={{ color: '#479760' }} className='arrowIcon' /></IconButton>
                    </Box>
                    <Table
                        key='select-products-table-1'
                        paginationMode='client'
                        className='contabil-grid'
                        rows={data1}
                        columns={useMemo(() => getcolumns1())}
                        innerRef={table1}
                        rowHeight={30}
                        checkbox={true}
                        pro={true}

                    />
                </Box>
                <Box sx={{ width: '50%', height: '28rem' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <IconButton onClick={() => toLeft(table2, setState, data1, data2)}><ArrowCircleLeftIcon sx={{ color: '#a14949' }} className='arrowIcon' /></IconButton>
                    </Box>
                    <Table
                        key='select-transfer-table-2'
                        paginationMode='client'
                        className='contabil-grid'
                        rows={data2}
                        columns={useMemo(() => getcolumns2())}
                        innerRef={table2}
                        rowHeight={30}
                        checkbox={true}
                        pro={true}
                    />
                </Box>
            </Box>

        </>
    )
}

export default TransferTable;